import { createActionCreator } from '../../../includes/enhanced-reducer';

export interface IViewModeSwitchPayload {
    viewMode: string;
}

const SET_VIEW_MODE = 'SET_VIEW_MODE';

export const setViewMode = createActionCreator<IViewModeSwitchPayload>(SET_VIEW_MODE);
